import { Link } from 'react-router-dom';
import heroImage from '@/assets/hero.jpg';

export default function HeroSection() {
  return (
    <section className="relative h-screen min-h-[700px] flex items-center justify-center overflow-hidden">
      <img
        src={heroImage}
        alt="ROFF"
        className="absolute inset-0 w-full h-full object-cover object-center"
      />
      <div className="absolute inset-0 bg-gradient-to-b from-white/20 via-white/10 to-white/30"></div>

      <div className="relative z-10 text-center w-full px-6">
        <div className="relative py-6">
          <div className="absolute -inset-x-8 -inset-y-12 md:-inset-x-16 md:-inset-y-10 bg-white/80 blur-2xl rounded-[3rem] -z-10"></div>
          <p className="text-xs tracking-[0.5em] text-primary-600 mb-5 uppercase"
            style={{ fontFamily: "var(--font-heading)" }}>
            Official Goods Store
          </p>
          <h1 className="text-6xl md:text-8xl font-light text-foreground-950 mb-6 tracking-[0.05em] leading-none"
            style={{ fontFamily: "var(--font-heading)" }}>
            ROFF
          </h1>
          <p className="text-sm md:text-base text-foreground-700 tracking-wider max-w-lg mx-auto leading-relaxed"
            style={{ fontFamily: "var(--font-body)" }}>
            かわいくて、ちゃんと使える。<br />
            あなたの毎日に寄り添うグッズブランド
          </p>
        </div>
        <div className="flex flex-col sm:flex-row gap-4 justify-center mt-10">
          <Link
            to="/products"
            className="inline-flex items-center gap-3 bg-primary-500 text-white px-10 py-4 text-sm tracking-[0.15em] hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer rounded-full"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            Shop Now
            <i className="ri-arrow-right-up-line text-lg"></i>
          </Link>
          <a
            href="#about"
            className="inline-flex items-center gap-2 border border-foreground-300 text-foreground-700 px-8 py-4 text-sm tracking-[0.15em] hover:bg-white/60 hover:border-primary-300 transition-colors whitespace-nowrap cursor-pointer rounded-full"
            style={{ fontFamily: "var(--font-heading)" }}
          >
            About ROFF
          </a>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 animate-bounce">
        <span className="text-[10px] text-foreground-500 tracking-[0.3em]" style={{ fontFamily: "var(--font-heading)" }}>Scroll</span>
        <i className="ri-arrow-down-line text-foreground-500 text-sm"></i>
      </div>
    </section>
  );
}